import { getAction, request } from "@/utils/http/service";
import { filterObj } from "@/utils/util";
import { appAdaptation } from "../../utils/convertData";

import { file_service } from "@/api/adminService";
import axios from "axios";
import { ls } from "@/utils/util";

export default {
    data() {
        return {
            //查询参数固定，一旦赋值重置不会改变
            queryParamFixed: {},
            queryParam: {},
            //数据集合
            dataSource: [],
            //加载状态
            loading: false,
            // 分页数据
            pagination: {
                current: 1,
                pageSize: 10,
                pageSizeOptions: ["10", "20", "30"],
                showQuickJumper: true,
                showSizeChanger: true,
                total: 0,
                showTotal: (total) => {
                    return "共" + total + "条";
                },
            },
            //多选参数
            selectedRowKeys: [],
            selectedRows: [],

            searchForm: {},

            record: {},

            immediateLoadData: true,
            loadAllData: false,
        };
    },
    mounted() {
        if (this.listUrl) {
            this.immediateLoadData && this.loadData();
        }
    },
    methods: {
        getIndex(index) {
            return (
                index +
                1 +
                (this.pagination.current - 1) * this.pagination.pageSize
            );
        },
        /*获取参数*/
        getParameters() {
            let params = {
                ...this.queryParam,
                ...this.queryParamFixed,
            };
            return filterObj(params);
        },
        /*加载数据*/
        loadData(pageNum) {
            const loadAllData = this.loadAllData;
            if (!this.listUrl) {
                this.$message.error("请设置listUrl属性!");
            } else {
                let params = this.getParameters();
                if (!loadAllData) {
                    params["pageNum"] = pageNum
                        ? pageNum
                        : this.pagination.current || 1;
                    params["pageSize"] = this.pagination.pageSize;
                }
                this.loading = true;
                getAction({
                    url: this.listUrl,
                    params: params,
                })
                    .then((data) => {
                        if(!loadAllData){
                            data = appAdaptation.pageData(data);
                        }
                        if (this.listKeyField) {
                            this.dataSource = (
                                loadAllData ? data : data.list
                            ).map((v) => {
                                return {
                                    key: v[this.listKeyField],
                                    ...v,
                                };
                            });
                        } else {
                            this.dataSource = loadAllData ? data : data.list;
                        }
                        if (!loadAllData) {
                            this.pagination.current = data.current;
                            this.pagination.total = data.total;
                        }
                        this.loading = false;
                    })
                    .catch((error) => {

                        if(error.response.status==544){
                            console.log('JWT报错')
                        }
                        this.loading = false;
                    });
            }
        },
        /*分页、排序、筛选变化时触发*/
        onTableChange(pagination, filters, sorter) {
            let self = this,
                pageNum = null;
            /*配置排序参数*/
            if (Object.keys(sorter).length > 0) {
                self.queryParam["column"] = sorter.field;
                self.queryParam["order"] =
                    "ascend" === sorter.order ? "asc" : "desc";
            }
            /*配置筛选参数*/
            Object.keys(filters).forEach((key) => {
                self.queryParam[key] = filters[key].join(",");
            });
            /*当pageSize改变、筛选、排序时，重置pageNumber为1*/
            if (
                pagination.pageSize !== this.pagination.pageSize ||
                Object.keys(filters).length > 0 ||
                Object.keys(sorter).length > 0
            ) {
                pageNum = 1;
            }
            this.pagination = pagination;
            this.loadData(pageNum);
        },
        /*选中项发生变化时的回调*/
        onSelectChange(selectedRowKeys, selectedRows) {

            this.selectedRowKeys = selectedRowKeys;
            this.selectedRows = [];
            let selectRowsSet = new Set(this.selectedRows);
            selectedRows.forEach((v) => {
                selectRowsSet.add(v);
            });
            this.selectedRows = Array.from(selectRowsSet).filter((v) => {
                return this.selectedRowKeys.includes(v.id);
            });
        },
        /*清空所有所有选择项*/
        onClearSelected() {
            this.selectedRowKeys = [];
            this.selectedRows = [];
        },
        /*批量操作设置*/
        onBatch(url,config = {},blur,) {
            let self = this;
            let { paramsField, pathVariable, method } = Object.assign(
                {
                    paramsField: "ids",
                    pathVariable: false,
                    method: "post",
                },
                config
            );
            if (!url) {
                self.$notification.error({
                    message: "请设置批量操作url地址",
                    style: {
                        fontWeight: '600',
                    },
                })
            } else {
                if (this.selectedRowKeys.length > 0) {
                    let ids = self.selectedRowKeys.join(",");
                    // self.loading = true;
                    request({
                        url: pathVariable ? url + ids : url,
                        params: {
                            [paramsField]: ids,
                            enabled: blur
                        },
                        method: method,
                        returnMsg: true,
                    })
                        .then((res) => {
                            self.$notification.success({
                                message: res.msg || "操作成功",
                                style: {
                                    fontWeight: '600',
                                },
                            })
                            self.onClearSelected();
                            self.loadData(1);
                        })
                        .catch(() => {
                            self.loading = false;
                        });
                } else {

                    self.$notification.warning({
                        message: "请选择一条记录！",
                        style: {
                            fontWeight: '600',
                        },
                    })
                }
            }
        },
        /*单项删除*/
        onDelete(id, config = {}) {
            const { paramsField, pathVariable, method } = Object.assign(
                {
                    paramsField: "ids",
                    pathVariable: false,
                    method: "post",
                },
                config
            );

            let self = this;
            if (!self.deleteUrl) {
                this.$message.error("请设置单项删除操作deleteUrl地址!");
            } else {
                request({
                    url: pathVariable ? self.deleteUrl + id : self.deleteUrl,
                    params: {
                        [paramsField]: id,
                    },
                    method: method,
                    returnMsg: true,
                }).then((res) => {
                    self.$message.success(res.msg || "删除成功");
                    self.selectedRows = self.selectedRows.filter((v) => {
                        return v[this.listKeyField] !== id;
                    });
                    self.selectedRowKeys = self.selectedRowKeys.filter((v) => {
                        return v !== id;
                    });
                    self.loadData();
                });
            }
        },
        onDeleteFn(id) {
            this.onDelete(id, { pathVariable: true, method: "delete" });
        },
        onDeleteBatch(url) {
            this.onBatch(url, { pathVariable: true, method: "delete" });
        },
        // switch
        onSwitchStatus(url, isShow) {
            if(isShow){
                this.onBatch(url,  { pathVariable: true, method: "post" },'0',);
            }else{
                this.onBatch(url, { pathVariable: true, method: "post" },'1');
            }
        },
        /*表单操作完成*/
        onFormEdited() {
            this.loadData();
        },
        /*筛选框点击搜索按钮*/
        onSearch() {
            this.$refs.searchForm
                .validate()
                .then(() => {
                    Object.keys(this.searchForm).forEach((key) => {
                        this.queryParam[key] = this.searchForm[key];
                    });
                    this.loadData(1);
                })
                .catch((error) => {
                    window.console.log("search error", error);
                });
        },
        /*筛选框点击重置按钮*/
        onReset() {
            this.$refs.searchForm.resetFields();
            this.queryParam = {};
            this.searchForm = {}
            this.loadData(1);
        },
        goBack(){
            this.$router.go(-1)
        },
        onSubmit() {
            this.visible = false;
            this.$emit("onCloseModel");
        },
        onClose() {
            this.visible = false;
            this.$emit("onCloseModel");
        },
        /*显示弹窗*/
        onShowModal(refName, data = {}) {
            const refEle = this.$refs[refName];
            refEle.form = Object.assign({}, data);
            refEle.visible = true;
        },
        onPreviewFile(file){
            axios({
                methods: 'get',
                url: file_service.download + file,
                responseType: 'blob',
                headers: {
                    Authorization: 'Bearer ' + ls.get('token') || ''
                }
            }).then(() => {
                const link = document.createElement("a"); // 创建a标签
                link.href = file_service.download + file;
                link.target = '_blank';
                link.click();
            })
        }
    },
};
